import {
  CONTRACT_GET_SERVICE_NUMBERS_REQUEST,
  CONTRACT_GET_SERVICE_NUMBERS_SUCCESS,
  CONTRACT_GET_SERVICE_NUMBERS_ERROR,
  CONTRACT_GET_SERVICE_NUMBERS_FOR_TERMINATE_NUMBER_REQUEST,
  CONTRACT_GET_SERVICE_NUMBERS_FOR_TERMINATE_NUMBER_SUCCESS,
  CONTRACT_GET_SERVICE_NUMBERS_FOR_TERMINATE_NUMBER_ERROR,
  CONTRACT_GET_SERVICE_NUMBERS_FOR_CHANGE_PLAN_REQUEST,
  CONTRACT_GET_SERVICE_NUMBERS_FOR_CHANGE_PLAN_SUCCESS,
  CONTRACT_GET_SERVICE_NUMBERS_FOR_CHANGE_PLAN_ERROR,
  CONTRACT_GET_PRICE_PLANS_SUCCESS,
  CONTRACT_GET_PRICE_PLANS_ERROR,
  CONTRACT_GET_ELIGIBILITY_SUCCESS,
  CONTRACT_GET_ELIGIBILITY_ERROR,
  CONTRACT_GET_EXISTINGVAS_REQUEST,
  CONTRACT_GET_EXISTINGVAS_SUCCESS,
  CONTRACT_GET_EXISTINGVAS_ERROR,
  FILTER_BY_EXPIRY_SUCCESS,
  FILTER_BY_EXPIRY_ERROR,
  ADDONS_EXISTINGVAS_REQUEST,
  ADDONS_EXISTINGVAS_SUCCESS,
  ADDONS_EXISTINGVAS_ERROR,
  CONTACT_EXPIRY_REQUEST,
  CONTACT_EXPIRY_SUCCESS,
  CONTACT_EXPIRY_ERROR,
  FILTER_BY_SIM_SUCCESS,
  FILTER_BY_SIM_ERROR,
  ACTIVATE_SIM_REQUEST,
  ACTIVATE_SIM_SUCCESS,
  ACTIVATE_SIM_ERROR,
  CONTRACT_GET_SERVICE_NUMBERS_WITH_NETWORK_REQUEST,
  CONTRACT_GET_SERVICE_NUMBERS_WITH_NETWORK_ERROR,
  CONTRACT_GET_SERVICE_NUMBERS_WITH_NETWORK_SUCCESS,
  CEASE_ADDONS_DETAILS_FAILURE,
  CEASE_ADDONS_DETAILS_REQUEST,
  CEASE_ADDONS_DETAILS_SUCCESS,
  CEASE_ADDONS_GET_SERVICE_NUMBERS_ERROR,
  CEASE_ADDONS_GET_SERVICE_NUMBERS_REQUEST,
  CEASE_ADDONS_GET_SERVICE_NUMBERS_SUCCESS,
  SUSPEND_LINE_GET_SERVICE_NUMBERS_SUCCESS,
  SUSPEND_LINE_GET_SERVICE_NUMBERS_REQUEST,
  SUSPEND_LINE_GET_SERVICE_NUMBERS_FAILURE,
  REFIT_LINE_SERVICE_NUMBERS_REQUEST,
  REFIT_LINE_SERVICE_NUMBERS_SUCCESS,
  REFIT_LINE_SERVICE_NUMBERS_ERROR,
  SUSPEND_LINE_SERVICE_NUMBERS_ELIGIBILITY_FAILURE,
  SUSPEND_LINE_SERVICE_NUMBERS_ELIGIBILITY_REQUEST,
  SUSPEND_LINE_SERVICE_NUMBERS_ELIGIBILITY_SUCCESS
} from '@/actions/contract/actionTypes';

export const initialState = {
  mobilePlanOptions: [],
  serviceNumbers: [],
  serviceNumberTotalRecords: 0,
  serviceNumbersLoading: false,
  eligibility: [],
  existingVas: [],
  addOnsExistingVas: [],
  existingVasStatus: '',
  fetchExistingError: '',
  existingVasLoading: false,
  addOnsExistingVasLoading: false,               ////unused key
  simFilter: [],
  expiryFilter: [],
  contactExpiryLoading: false,                   ////unused key
  activateSimLoading: false,                     ////unused key
  activateSimData: {},
  addons: [],
  serviceNumberswithNT: [],
  serviceNumbersWithNTLoading: false,
  ceaseAddonsErrors: '',
  serviceNumbersRefitLoading: false,
  serviceNumbersRefitStatus: false,
  serviceNumbersRefitError: '',
  serviceNumbersRefit: {},
  serviceNumbersRefitEligible: '',
  mobilePlanLoading: false,
  suspendNumbers: [],
  suspendNumberLoading: false,
  suspendNumberTotalRecord: 0,
  suspendNumberEligibleLoading: false,
  eligibleNumberError: ''
};

const contractReducers = (state = initialState, action) => {
  switch (action.type) {
    case CONTRACT_GET_SERVICE_NUMBERS_REQUEST:
    case CONTRACT_GET_SERVICE_NUMBERS_FOR_TERMINATE_NUMBER_REQUEST:
    case CONTRACT_GET_SERVICE_NUMBERS_FOR_CHANGE_PLAN_REQUEST:
    case CEASE_ADDONS_GET_SERVICE_NUMBERS_REQUEST:
    case CEASE_ADDONS_DETAILS_REQUEST:
      return {
        ...state,
        serviceNumbersLoading: true,
        ceaseAddonsErrors: ''
      };

    case CONTRACT_GET_SERVICE_NUMBERS_SUCCESS:
    case CONTRACT_GET_SERVICE_NUMBERS_FOR_TERMINATE_NUMBER_SUCCESS:
    case CONTRACT_GET_SERVICE_NUMBERS_FOR_CHANGE_PLAN_SUCCESS:
      return {
        ...state,
        serviceNumbers: action.data.data,
        serviceNumberTotalRecords: action.data.totalRecords,
        serviceNumbersLoading: false
      };

    case CONTRACT_GET_SERVICE_NUMBERS_ERROR:
    case CONTRACT_GET_SERVICE_NUMBERS_FOR_TERMINATE_NUMBER_ERROR:
    case CONTRACT_GET_SERVICE_NUMBERS_FOR_CHANGE_PLAN_ERROR:
    case CEASE_ADDONS_GET_SERVICE_NUMBERS_ERROR:
      return {
        ...state,
        serviceNumbers: [],
        serviceNumbersLoading: false
      };
    case SUSPEND_LINE_GET_SERVICE_NUMBERS_FAILURE:
      return {
        ...state,
        suspendNumbers: [],
        suspendNumberLoading: false
      };

    case CONTRACT_GET_PRICE_PLANS_SUCCESS:
      return {
        ...state,
        mobilePlanOptions: action.data
      };
    case CONTRACT_GET_PRICE_PLANS_ERROR:
      return {
        ...state,
        mobilePlanOptions: []
      };

    case CONTRACT_GET_ELIGIBILITY_SUCCESS:
      return {
        ...state,
        eligibility: action.data
      };
    case CONTRACT_GET_ELIGIBILITY_ERROR:
      return {
        ...state,
        eligibility: []
      };

    case ADDONS_EXISTINGVAS_REQUEST:
      return {
        ...state,
        addOnsExistingVas: [],
        addOnsExistingVasLoading: true
      };
    case ADDONS_EXISTINGVAS_SUCCESS:
      return {
        ...state,
        addOnsExistingVasLoading: false,
        addOnsExistingVas: action.data
      };
    case ADDONS_EXISTINGVAS_ERROR:
      return {
        ...state,
        addOnsExistingVasLoading: false,
        addOnsExistingVas: []
      };

    case CONTACT_EXPIRY_REQUEST:
      return {
        ...state,
        contactExpiryLoading: true
      };
    case CONTACT_EXPIRY_SUCCESS:
      return {
        ...state,
        contactExpiryLoading: false,
        contactExpiryList: action.data
      };
    case CONTACT_EXPIRY_ERROR:
      return {
        ...state,
        contactExpiryLoading: false,
        contactExpiryList: []
      };

    case CONTRACT_GET_EXISTINGVAS_REQUEST:
      return {
        ...state,
        existingVasLoading: true,
        existingVasStatus: '',
        fetchExistingError: ''
      };
    case CONTRACT_GET_EXISTINGVAS_SUCCESS:
      return {
        ...state,
        existingVas: action.data.data,
        existingVasStatus: action.data.status,
        existingVasLoading: false
      };
    case CONTRACT_GET_EXISTINGVAS_ERROR:
      return {
        ...state,
        existingVas: [],
        existingVasStatus: 'FAIL',
        existingVasLoading: false,
        fetchExistingError: action.error.response?.data?.code,
      };

    case FILTER_BY_EXPIRY_SUCCESS:
      return {
        ...state,
        expiryFilter: action.data
      };
    case FILTER_BY_EXPIRY_ERROR:
      return {
        ...state,
        expiryFilter: []
      };

    case FILTER_BY_SIM_SUCCESS:
      return {
        ...state,
        simFilter: action.data
      };
    case FILTER_BY_SIM_ERROR:
      return {
        ...state,
        simFilter: []
      };

    case ACTIVATE_SIM_REQUEST:
      return {
        ...state,
        activateSimLoading: true
      };
    case ACTIVATE_SIM_SUCCESS:
      return {
        ...state,
        activateSimData: action.data,
        activateSimLoading: false
      };
    case ACTIVATE_SIM_ERROR:
      return {
        ...state,
        activateSimLoading: false
      };

    case CONTRACT_GET_SERVICE_NUMBERS_WITH_NETWORK_REQUEST:
      return {
        ...state,
        serviceNumbersWithNTLoading: true
      };
    case CONTRACT_GET_SERVICE_NUMBERS_WITH_NETWORK_SUCCESS:
      return {
        ...state,
        serviceNumberswithNT: action.data?.data,
        serviceNumbersWithNTLoading: false,
        simCharge: action.data?.simCharge,
        serviceNumberNTTotalRecords: action.data?.totalRecords
      };
    case CONTRACT_GET_SERVICE_NUMBERS_WITH_NETWORK_ERROR:
      return {
        ...state,
        serviceNumbersWithNTLoading: false
      };

    case CEASE_ADDONS_GET_SERVICE_NUMBERS_SUCCESS:
      return {
        ...state,
        serviceNumbers: action.data.serviceNoAddOnResponseList,
        serviceNumberTotalRecords: action.data.totalRecords,
        serviceNumbersLoading: false
      };
    case SUSPEND_LINE_GET_SERVICE_NUMBERS_REQUEST:
      return {
        ...state,
        suspendNumberLoading: true,
        eligibleNumberError: ''
      };
    case SUSPEND_LINE_GET_SERVICE_NUMBERS_SUCCESS:
      return {
        ...state,
        suspendNumbers: action.data.data,
        suspendNumberTotalRecord: action.data.totalRecords,
        suspendNumberLoading: false
      };
    case SUSPEND_LINE_SERVICE_NUMBERS_ELIGIBILITY_REQUEST:
      return {
        ...state,
        eligibleNumberError: '',
        suspendNumberEligibleLoading: true
      };
    case SUSPEND_LINE_SERVICE_NUMBERS_ELIGIBILITY_SUCCESS:
      return {
        ...state,
        suspendNumberEligibleLoading: false
      };
    case SUSPEND_LINE_SERVICE_NUMBERS_ELIGIBILITY_FAILURE:
      return {
        ...state,
        eligibleNumberError: action.error.response?.data?.message,
        suspendNumberEligibleLoading: false
      };
    case CEASE_ADDONS_DETAILS_SUCCESS:
      return {
        ...state,
        addons: action.data,
        serviceNumbersLoading: false
      };
    case CEASE_ADDONS_DETAILS_FAILURE:
      return {
        ...state,
        addons: [],
        ceaseAddonsErrors: 'CEASE_ADDONS_UNABLE_TO_FETCH_DETAIL_ERROR',
        serviceNumbersLoading: false
      };
   
    case REFIT_LINE_SERVICE_NUMBERS_REQUEST:
      return {
        ...state,
        serviceNumbersRefitLoading: true,
        serviceNumbersRefit: {},
        serviceNumbersRefitStatus: false,
        serviceNumbersRefitError: '',
        serviceNumbersRefitEligible:''
      };
    case REFIT_LINE_SERVICE_NUMBERS_SUCCESS:
      return {
        ...state,
        serviceNumbersRefitLoading: false,
        serviceNumbersRefit: action.data.data,
        serviceNumbersRefitStatus: action.data.data?.status,
        serviceNumbersRefitEligible: action.data.data?.eligibility,
      };
    case REFIT_LINE_SERVICE_NUMBERS_ERROR:
      return {
        ...state,
        serviceNumbersRefitLoading: false,
        serviceNumbersRefitError: action.error.response?.data?.message
      };
      
    default:
      return state;
  }
};

export default contractReducers;
